import { onMounted, onUnmounted } from 'vue';

export function useMobileViewport() {
  let frame = 0;
  const update = () => {
    const viewport = window.visualViewport;
    const height = viewport?.height ?? window.innerHeight;
    document.documentElement.style.setProperty('--visual-viewport-height', `${height}px`);
    document.documentElement.style.setProperty("--keyboard-inset", `${Math.max(0, window.innerHeight - height - (viewport?.offsetTop ?? 0))}px`);
    const active = document.activeElement;
    const editing =
      active instanceof HTMLElement &&
      active.matches('input, textarea, select, [contenteditable="true"]');
    document.documentElement.dataset.keyboardOpen = String(
      editing && window.innerHeight - height > 120,
    );
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      if (editing && viewport && viewport.scale === 1) {
        const rect = active.getBoundingClientRect();
        if (rect.bottom > viewport.offsetTop + height - 24 || rect.top < viewport.offsetTop) {
          active.scrollIntoView({ block: 'center', behavior: 'instant' });
        }
      }
    });
  };
  onMounted(() => {
    window.visualViewport?.addEventListener('resize', update);
    window.visualViewport?.addEventListener('scroll', update);
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', update);
    update();
  });
  onUnmounted(() => {
    cancelAnimationFrame(frame);
    window.visualViewport?.removeEventListener('resize', update);
    window.visualViewport?.removeEventListener('scroll', update);
    document.removeEventListener('focusin', update);
    document.removeEventListener('focusout', update);
    delete document.documentElement.dataset.keyboardOpen;
    document.documentElement.style.removeProperty('--visual-viewport-height');
    document.documentElement.style.removeProperty('--keyboard-inset');
  });
}
